export default {
  '***': {
    '***': {
      displayFilters: null,
      staticFilters: [
        {
          label: 'Age',
          code: 'age',
          multi: true,
          options: [
            {
              label: '18-34',
              value: 1,
              selected: false
            },
            {
              label: '35-54',
              value: 2,
              selected: false
            },
            {
              label: '55+',
              value: 3,
              selected: false
            }
          ]
        },
        {
          label: 'Gender',
          code: 'gender',
          multi: true,
          options: [
            {
              label: 'Male',
              value: 1,
              selected: false
            },
            {
              label: 'Female',
              value: 2,
              selected: false
            },
            {
              label: 'Other',
              value: 3,
              selected: false
            }
          ]
        },
        
        {
          label: 'Ethnicity',
          code: 'ethnicity',
          multi: true,
          options: [
            {
              label: 'White',
              value: 1,
              selected: false
            },
            {
              label: 'Black',
              value: 2,
              selected: false
            },
            {
              label: 'Latino',
              value: 3,
              selected: false
            },
            {
              label: 'Asian',
              value: 4,
              selected: false
            },
            {
              label: 'American Indian',
              value: 5,
              selected: false
            },
            {
              label: 'Middle Eastern/North African',
              value: 6,
              selected: false
            },
            {
              label: 'Hawaiian/Pacific Islander',
              value: 7,
              selected: false
            },
            {
              label: 'Other',
              value: 8,
              selected: false
            }
          ]
        },
        {
          label: 'Avid Sports Fan',
          code: 'sports',
          multi: true,
          options: [
            {
              label: 'Sports Fan',
              value: 1,
              selected: false
            },
            {
              label: 'Not an avid fan of any sport',
              value: 2,
              selected: false
            }
          ]
        },
        {
          label: 'Insurance Products Held',
          code: 'insurance',
          multi: true,
          options: [
            {
              label: 'Home and Auto',
              value: 1,
              selected: false
            },
            {
              label: 'Auto Only',
              value: 2,
              selected: false
            },
            {
              label: 'No Auto (neither type or only home)',
              value: 3,
              selected: false
            }
            
          ]
        } 
      ]
    }
  }
};



// WEBPACK FOOTER //
// ./src/app/configuration/Insurance/config/components/scorecard/ScorecardView/ScorecardFilter/index.js